import { render, staticRenderFns } from "./UseCase.vue?vue&type=template&id=2153055d&scoped=true"
import script from "./UseCase.vue?vue&type=script&lang=js"
export * from "./UseCase.vue?vue&type=script&lang=js"
import style0 from "./UseCase.vue?vue&type=style&index=0&id=2153055d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2153055d",
  null
  
)

export default component.exports